import { useRuntimeConfig, defineNuxtPlugin } from '#imports';
import { consola } from 'consola/basic';

export default defineNuxtPlugin(() => {
  const config = useRuntimeConfig();

  consola.info(config.public.appVersion);
});
